import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import React from 'react'
import { WorkMergeVote } from '@Entities/rightsholder/work-merge'
import { workMergeStatusText } from '@Scenes/RightsholderScene/WorkMerge/WorkMergeStatusPill'
import './index.scss'

export interface WorkMergeVoteConfirmationPopupProps {
    vote: WorkMergeVote
    onClose: () => void
}

const WorkMergeVoteConfirmationPopup = (props: WorkMergeVoteConfirmationPopupProps) => {
    const { vote, onClose } = props
    return (
        <Popup className="work-merge-vote-popup-wrapper" onClose={onClose} showClose>
            <ConfirmationPopup
                title={`Work Merge Request ${workMergeStatusText[vote]}`}
                onConfirm={onClose}
                confirmButtonText="Done"
            >
                <span>
                    Your request is now under review. If approved, updates may take up to 48 hours to appear in your
                    catalog.
                </span>
            </ConfirmationPopup>
        </Popup>
    )
}
export default WorkMergeVoteConfirmationPopup
